<template>
    <v-expansion-panels v-model="panel">
        <v-expansion-panel>
            <v-expansion-panel-header class="headline">{{ $t('filters') }}</v-expansion-panel-header>
            <v-expansion-panel-content>
                <slot></slot>
            </v-expansion-panel-content>
        </v-expansion-panel>
    </v-expansion-panels>
</template>

<script>
    export default {
        name: 'FiltersExpansion',
        props: {
            opened: {
                required: false,
                type: Boolean,
                default: false,
            }
        },
        data() {
            return {
                panel: null,
            }
        },
        watch: {
            opened: {
                handler(value) {
                    this.panel = value ? 0 : null;
                },
                immediate: true,
            }
        }
    }
</script>

<style scoped>

</style>
